import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 立陶宛
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Visos teisės saugomos',
    },
    auth: {
        login: 'Prisijungti',
        username: 'Vartotojo vardas',
        username_placeholder: 'Įveskite vartotojo vardą',
        password: 'Slaptažodis',
        password_placeholder: 'Įveskite slaptažodį',
        code: 'Patvirtinimo kodas',
        code_placeholder: 'Įveskite patvirtinimo kodą',
        logout: 'Atsijungti',
        logout_success: 'Sėkmingai atsijungėte',
        day: 'diena',
        password_expiration: 'Slaptažodžio galiojimo laikas baigėsi – prašome jį pakeisti',
        expire: 'Iki slaptažodžio galiojimo pabaigos liko',
        conseils:
            'Privalo būti didžiosios raidės, mažosios raidės, skaičiai ir specialieji simboliai ({msg}). Slaptažodžio ilgis turi būti nuo 8 iki 16 simbolių.',
        brand_Selection: 'Prekės ženklo pasirinkimas',
        unread_notices: 'Neskaityti pranešimai',
        new_cases: 'Nauji atvejai',
        unanswered_cases: 'Neatsakyti atvejai',
        overdue_cases: 'Vėluojantys atvejai',
    },
    button: {
        query: 'Užklausa',
        editing_position: 'Redaguoti pareigas',
        show_theme_editor: 'Rodyti / slėpti temos redaktorių',
        change_password: 'Keisti slaptažodį',
        old_password: 'Senas slaptažodis',
        new_password: 'Naujas slaptažodis',
        confirm_password: 'Patvirtinti slaptažodį',
        button: 'Mygtukas',
        about: 'Apie',
        back: 'Atgal',
        go: 'Gerai',
        home: 'Pagrindinis puslapis',
        confirm: 'Patvirtinti',
        modify: 'Keisti',
        edit: 'Redaguoti',
        new: 'Naujas',
        cancel: 'Atšaukti',
        close: 'Uždaryti',
        search: 'Ieškoti',
        reset: 'Atstatyti',
        delete: 'Ištrinti',
        add: 'Pridėti',
        collapse: 'Suskleisti',
        expand: 'Išskleisti',
        download_template: 'Atsisiųsti šabloną',
        batch_import: 'Masinis importas',
        import: 'Importuoti',
        export: 'Eksportuoti',
        export_fail: 'Importas nepavyko',
        detailed: 'Išsamiai',
        details: 'Išsamiai',
        download: 'Atsisiųsti',
        toView: 'Peržiūrėti',
        toViews: 'Peržiūrėti paveikslėlius',
        uploadAttachments: 'Įkelti priedus',
        selectFile: 'Pasirinkite failą',
        fillingInstructions: 'Užpildymo instrukcijos',
        release: 'Publikuoti',
        release_recall: 'Atšaukti publikavimą',
        save: 'Išsaugoti',
        send: 'Siųsti',
        tips: 'Patarimai',
        send_back: 'Grąžinti',
        examine: 'Patikrinti',
        void: 'Anuliuoti',
        more: 'Daugiau',
        refresh: 'Atnaujinti',
        selects: 'Pasirinkite',
        serial_number: 'Eilės numeris',
        upload_progress: 'Įkėlimo progresas',
        invalid: 'Negaliojantis',
        daily_record: 'Dienos žurnalas',
        operation_type: 'Operacijos tipas',
        field_name: 'Lauko pavadinimas',
        edit_role: 'Redaguoti rolę',
        user_role: 'Pasirinkite rolę',
        assignment_role: 'Rolė',
        post: 'Pareigos',
        sending: 'Siunčiama...',
        reset_password: 'Atstatyti slaptažodį',
        display_or_not: 'Rodyti ar ne',
        document: 'Dokumentas',
        specificTemplates: 'Specifiniai šablonai',
        transferOrder: 'Perkelti užsakymą',
        forwarding: 'Persiųsti',
        one_click_notification: 'Pranešimas vienu paspaudimu',
        english_export: 'Eksportas anglų kalba',
        oneclick_download: 'Atsisiųsti vienu paspaudimu',
        passwordmsga:
            'Privalo būti didžiosios raidės, mažosios raidės, skaičiai ir specialieji simboliai (@\\$!_~\\&*)',
        passwordmsgb: 'Slaptažodžio ilgis turi būti nuo 8 iki 16 simbolių',
        passwordmsgc: 'Negali sutapti su bet kuriuo iš paskutinių šešių slaptažodžių',
        export_file_list: 'Eksportuotų failų sąrašas',
        personal_center: 'Asmeninis centras',
        upload_list: 'Įkėlimų sąrašas',
        clear_completed: 'Išvalyti užbaigtus',
    },
    radio: {
        enabled: 'Įjungta',
        disabled: 'Išjungta',
        catalogue: 'Katalogas',
        individual: 'Individualus',
        all: 'Visi',
        yes: 'Taip',
        no: 'Ne',
    },
    dropdown: {
        close_others: 'Uždaryti kitus',
        close_right: 'Uždaryti dešinėje',
        close_left: 'Uždaryti kairėje',
    },
    table: {
        action: 'Veiksmas',
        explain: 'Paaiškinimas',
        fileName: 'Failo pavadinimas',
        size: 'Dydis (MB)',
        uploader: 'Įkėlė',
        uploadTime: 'Įkėlimo laikas',
        system: 'Sistema',
        caption: 'Antraštė',
        categorization: 'Kategorizavimas',
        link: 'Nuoroda',
        forwarding_time: 'Persiuntimo laikas',
        forwarder: 'Persiuntė',
        send_to: 'Siųsti kam',
        mode: 'Režimas',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} puslapis`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Iš viso ${named('number')} įrašų`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Iš viso ${named('number')} transporto priemonių`,
    },
    confirm: {
        confirm_deletion: 'Patvirtinti ištrynimą?',
        confirm_void: 'Patvirtinti anuliavimą?',
        confirm_release: 'Patvirtinti publikavimą?',
        ack: 'Patvirtinti',
        cancel: 'Atšaukti',
        non_records: 'Pasirinkite bent vieną įrašą',
    },
    request: {
        failed_placeholder: 'Užklausa nepavyko – serverio klaida',
        success_placeholder: 'Užklausa sėkminga',
        auth: {
            login_success: 'Sėkmingai prisijungėte',
        },
        error: {
            '404': 'Užklausos kelias nerastas',
            '403': 'Nepakankamos teisės',
        },
    },
    page: {
        global: {
            page_search: 'Puslapio paieška',
        },
        error: {
            not_found: 'Puslapis nerastas',
            not_found_des: 'Čia nieko nėra',
            auth_failed: 'Nepakankamos teisės',
            auth_failed_des: 'Šis puslapis draudžiamas',
            file_format_error: 'Netinkamas failo formatas!',
            preview_failed: 'Peržiūra nepavyko! Failas sugadintas!',
        },
        homepage: {
            homepage: homepage.homepage.ltLT,
        },
        system: {
            menu: system.menu.ltLT,
            dict: system.dict.ltLT,
            dept: system.dept.ltLT,
            role: system.role.ltLT,
            user: system.user.ltLT,
        },
        info: {
            announcement: Info.announcement.announcement.ltLT,
            document: Info.document.document.ltLT,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.ltLT,
                recallActivity: tech.quality.recallActivity.ltLT,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.ltLT,
            },
            management: {
                inquiryOd: tech.management.inquiry.ltLT,
                permission: tech.management.permission.ltLT,
                onSiteSupportHq: tech.management.onSiteSupport.ltLT,
                progHistoryHq: tech.management.progHistory.ltLT,
                salesRecordHq: tech.management.salesRecord.ltLT,
                vehicleInfoHq: tech.management.vehicleInfo.ltLT,
                claimHq: tech.management.claim.ltLT,
                filterHq: tech.management.filter.ltLT,
                newCarlssue: tech.management.newCarIssue.ltLT,
                newCarDefinition: tech.management.newCarDefinition.ltLT,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.ltLT,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.ltLT,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.ltLT,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.ltLT,
        },
        statistics: statistics.inquiryStatistics.ltLT,
        systemClassifyA: statistics.systemClassifyA.ltLT,
        systemClassifyB: statistics.systemClassifyB.ltLT,
        engineerStatistics: statistics.engineerStatistics.ltLT,
        defectivePart: statistics.defectivePart.ltLT,
        replyInquiryStatistics: statistics.replyInquiryStatistics.ltLT,
        passRateStatistics: statistics.passRateStatistics.ltLT,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.ltLT,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.ltLT,
        customsClearance135Rate: statistics.customsClearance135Rate.ltLT,
        accumulatedClosureRate: statistics.accumulatedClosureRate.ltLT,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.ltLT,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.ltLT,
    },
    validation: {
        common: {
            required: 'Šis laukas privalomas',
            numeric: 'Turi būti sveikasis skaičius',
            decimal: 'Turi būti skaičius',
            positive_interger: 'Turi būti teigiamas sveikasis skaičius',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maksimaliai ${named('number')} skaitmenų`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Neturi viršyti ${named('number')} simbolių`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Viršytas maksimalus simbolių skaičius (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Turi būti bent ${named('number')} simbolių`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Turi būti lygiai ${named('number')} simbolių`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Negali būti didesnis nei ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Negali būti mažesnis nei ${named('number')}`,
            up_to_2_decimal_places: 'Maksimaliai 2 skaitmenys po kablelio',
            retain_up: 'Maksimaliai 10 skaitmenų prieš kablelį, maksimaliai 2 po kablelio',
            retain_ups: 'Maksimaliai 11 skaitmenų prieš kablelį, maksimaliai 4 po kablelio',
            input_number: 'Įveskite arabų skaitmenis',
            only_number_a: 'Leidžiami tik raidės arba skaičiai',
            translate: 'Leidžiamos tik raidės',
            positive_integer: 'Užpildykite bent vieną lauką',
            at_least_one: 'Užpildykite bent vieną',
        },
        tip: {
            incomplete_information: 'Informacija neužpildyta pilnai',
        },
    },
    import: {
        template_file: 'Šablono failas',
        browse: 'Naršyti',
        download_template: 'Atsisiųsti šabloną',
        no_file_selected: 'Failas nepasirinktas',
        incorrect_file_type: 'Netinkamas failo tipas',
        exceed: 'Viršytas limitas',
        upload_success: 'Įkėlimas sėkmingas',
        upload_fail: 'Įkėlimas nepavyko',
        again_upload:
            'Galima įkelti tik jpg, png, bmp arba gif formato paveikslėlius. Bandykite dar kartą.',
        attachmentUpload: 'Priedų įkėlimas',
        otherAttachmentUpload: 'Kitų priedų įkėlimas',
        supportedFormats: 'Palaikomi formatai',
        preview: 'Peržiūra',
    },
    export: {
        noDataToExport: 'Nėra duomenų eksportui',
    },
    select: {
        all: 'Visi',
    },
    checkbox: {
        select_all: 'Pažymėti viską',
    },
    dialog: {
        error_message: 'Klaidos pranešimas',
        one_year: 'Vienu metu galima eksportuoti ne daugiau kaip vienerių metų duomenis',
    },
    ymd: {
        year: 'metai',
        month: 'mėnuo',
        day: 'diena',
        week: 'savaitė',
        january: 'Sausis',
        february: 'Vasaris',
        march: 'Kovas',
        april: 'Balandis',
        may: 'Gegužė',
        june: 'Birželis',
        july: 'Liepa',
        august: 'Rugpjūtis',
        september: 'Rugsėjis',
        october: 'Spalis',
        november: 'Lapkritis',
        december: 'Gruodis',
    },
};
